/* Publish by EComposer at 2025-08-08 17:55:33*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ryb9ihvywh"]=  window.__ectimmers["ecom-ryb9ihvywh"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ryb9ihvywh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ryb9ihvywh', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xb3warujrsr"]=  window.__ectimmers["ecom-xb3warujrsr"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-xb3warujrsr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xb3warujrsr', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nra8en2b1kr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nra8en2b1kr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fgwe97vtvbw"]=  window.__ectimmers["ecom-fgwe97vtvbw"] || {};
if(!this.settings||!this.$el)return;const e=this.$el,i=this.isLive,t=this.settings.loop,n=this.settings.autoplay,s=this.settings.lazyload||!1,o=this.settings.player_controls||!1,a=this.settings.pause_on_hover||!1,r=this.settings.click_to_play_pause,c=this.settings.play_on_lightbox||!1,m=1;let l=e.querySelector(".ecom-video_overlay-icon");const h=e.querySelector(".ecom-video-poster");let y;y=l&&l.querySelector(".ecom-video-icon-play");const g=e.querySelector(".ecom-element_video-iframe");s&&setTimeout(function(){b(g)},500);function b(L){let z={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver($,z).observe(L)}function u(L,z){let M={handleMouseenter:T,handleMouseleave:S,handleEnded:q};function T(){L.readyState>=m&&L.pause()}function S(){L.readyState>=m&&L.play()}function q(){v(L,M)}if(a){L.addEventListener("mouseenter",T),L.addEventListener("mouseleave",S);let P=e.querySelector(".ecom-video_link-extra");P&&P.href&&(P.addEventListener("mouseenter",T),P.addEventListener("mouseleave",S)),z||L.addEventListener("ended",q)}}function v(L,z){if(z){const{handleMouseenter:M,handleMouseleave:T,handleEnded:S}=z;let q=e.querySelector(".ecom-video_link-extra");L.removeEventListener("mouseenter",M),L.removeEventListener("mouseleave",T),L.removeEventListener("ended",S),q&&q.href&&(q.removeEventListener("mouseenter",M),q.removeEventListener("mouseleave",T))}}function $(L,z){L.forEach(function(M){if(M.isIntersecting){const T=M.target.querySelector("video source"),S=M.target.querySelector("video"),q=M.target.querySelector("iframe");if(S&&T&&(T.src=T.dataset.source,S.load(),S.addEventListener("loadeddata",function(){n&&S.play()})),q){let P=q.dataset.srcVideo;q.setAttribute("src",P)}z.unobserve(M.target)}})}let x=e.querySelector(".ecom_video"),w=e.querySelector(".ecom_iframe");r&&x.addEventListener("click",()=>{x.readyState>=m&&(x.paused?x.play():x.pause())}),n&&(l&&l.classList.remove("ecom-overlay"),y&&(y.style.display="none"),h&&(h.style.display="none")),x&&!t&&x.addEventListener("ended",function(){h&&(h.style.display="block"),l&&l.classList.add("ecom-overlay"),y&&(y.style.display="block")}),l&&l.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&x)h&&(h.style.display="none"),x.autoplay=!0,x.play(),l.classList.remove("ecom-overlay"),y.style.display="none";else if(w){let L=w.getAttribute("src");L.includes("autoplay=0")?L=L.replace("autoplay=0","autoplay=1"):L=L+"&autoplay=1",w.setAttribute("src",L),c?setTimeout(()=>{L=L.replace("autoplay=1","autoplay=0"),w.setAttribute("src",L)},100):(h&&(h.style.display="none"),l.classList.remove("ecom-overlay"),y.style.display="none")}}),x&&(i&&!h&&u(x,t),h&&h.addEventListener("click",function(){h.style.display="none",x.play(),i&&u(x,t)}),a||x.addEventListener("pause",function(){h&&(h.style.display="block"),l&&l.classList.add("ecom-overlay"),y&&(y.style.display="block")}),!o&&l&&x.addEventListener("click",function(){x.pause()})),e.querySelectorAll("[data-ec-tracking-id]").forEach(function(L){L.dataset.ecTrackingId&&L.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:L.id,tracking_id:L.dataset.ecTrackingId})},{once:!0})});const f=e.querySelector("[ecom-modal]");if(f&&this.settings.image_overlay&&c&&window.EComModal){const L=f.dataset.width,z=f.dataset.height;var k=this.id;new window.EComModal(f,{cssClass:[k,"ecom-core","ecom-core-simulator"],onOpen:function(){var M=document.querySelector(".ecom-modal."+k);if(M){const T=M.querySelector(".ecom-modal-box__content");T.classList.add("ecom-element_video-iframe");const S={width:L,height:z};Object.assign(T.style,S)}},onClose:function(){var M=document.querySelector(".ecom-modal."+k);if(M){const T=M.querySelector(".ecom-element_video-iframe iframe");T&&(T.src="")}}})}

                    });
                    
                        document.querySelectorAll('.ecom-fgwe97vtvbw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fgwe97vtvbw', settings: {"autoplay":true,"player_controls":false,"source":"uploaded"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-l1sdhijfpqj"]=  window.__ectimmers["ecom-l1sdhijfpqj"] || {};
let $el = this.$el
                if(!$el) return;

                let isLive = this.isLive,
                    $items = $el.querySelectorAll(".ecom-collection__product-item"),
                    show_progress_pagination = this.settings.enable_progress_pagination ?? false,
                    flagInfinite = true;
                if($items){
                    $items.forEach(function(item){
                        let $quantity = item.querySelector(".ecom-collection__product-quantity-input");
                        let $plus = item.querySelector(".ecom-collection__quantity-controls-plus");
                        let $minus = item.querySelector(".ecom-collection__quantity-controls-minus");
                        if($minus){
                            $minus.addEventListener('click', function(){
                                $quantity.stepDown();
                                $quantity.dispatchEvent(new Event('change'));
                            })
                        }
                        if($plus){
                            $plus.addEventListener('click', function(){
                                $quantity.stepUp();
                                $quantity.dispatchEvent(new Event('change'));
                            })
                        }
                        if($quantity) {
                            $quantity.addEventListener('change', function(e){
                                let tagA = item.querySelector('a.ecom-collection__product-submit');
                                if(e.target.value > parseInt(e.target.max)){
                                    e.target.value = parseInt(e.target.max);
                                }
                                if(tagA){
                                    let link = tagA.getAttribute('href');
                                    tagA.setAttribute('href', link.replace(/quantity=(\d*)/gm, `quantity=${e.target.value}`));
                                }
                                
                            })
                        }
                    });
                    
                }
                
                if (this.settings.layout === "slider") {

                    let $el = this.$el,
                        $container = $el.querySelector(".ecom-swiper-container"),
                        optionSwiper = $container && $container.dataset.optionSwiper;
                    if (!optionSwiper) {
                        return;
                    }
                    optionSwiper = JSON.parse(optionSwiper);
                    optionSwiper.pagination = {
                        el: $el.querySelector(".ecom-swiper-pagination"),
                        type: "bullets",
                        clickable: true
                    };
                    optionSwiper.navigation = {
                        nextEl: $el.querySelector(".ecom-swiper-button-next"),
                        prevEl: $el.querySelector(".ecom-swiper-button-prev")
                    };
                    optionSwiper.autoHeight = false;
                    new window.EComSwiper($container, optionSwiper);
                }
                // $doms.forEach(executeShopifyOptionSelectors);

                /**
                 * Countdown
                 */
                const $main = $el.querySelector(".ecom-collection__product-main");
                let trans = $main.dataset,
                    shows = $main.dataset.countdownShows;
                const regex = /\[([^\]]+)\]/gm;
                var format = "";
                if (shows.indexOf("week") >= 0 && trans.week) {
                    let number = "";
                    let text = trans.week.replace(regex, (...m) => {
                        number = m[1];
                        return "";
                    });
                    format += `
                            <div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--week">
                                <span class="ecom-collection__product-time--number">
                                    ${number}
                                </span>
                                <span class="ecom-collection__product-time--label">
                                    ${text}
                                </span>
                            </div>`;
                }
                if (shows.indexOf("day") >= 0 && trans.day) {
                    let number = "";
                    let text = trans.day.replace(regex, (...m) => {
                        number = m[1];
                        return "";
                    });
                    format += `<div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--day">
                                    <span class="ecom-collection__product-time--number">
                                        ${number}
                                    </span>
                                    <span class="ecom-collection__product-time--label">
                                        ${text}
                                    </span>
                                </div> `;
                }
                if (shows.indexOf("hour") >= 0 && trans.hour) {
                    let number = "";
                    let text = trans.hour.replace(regex, (...m) => {
                        number = m[1];
                        return "";
                    });
                    format += `
                            <div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--hour">
                                <span class="ecom-collection__product-time--number">
                                    ${number}
                                </span>
                                <span class="ecom-collection__product-time--label">
                                    ${text}
                                </span>
                            </div>
                        `;
                }
                if (shows.indexOf("minute") >= 0 && trans.minute) {
                    let number = "";
                    let text = trans.minute.replace(regex, (...m) => {
                        number = m[1];
                        return "";
                    });
                    format += `<div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--minute">
                                    <span class="ecom-collection__product-time--number">
                                        ${number}
                                    </span>
                                    <span class="ecom-collection__product-time--label">
                                        ${text}
                                    </span>
                                </div>
                            `;
                }
                if (shows.indexOf("second") >= 0 && trans.second) {
                    let number = "";
                    let text = trans.second.replace(regex, (...m) => {
                        number = m[1];
                        return "";
                    });
                    format += `<div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--second">
                                    <span class="ecom-collection__product-time--number">
                                        ${number}
                                    </span>
                                    <span class="ecom-collection__product-time--label">
                                        ${text}
                                    </span>
                                </div>`;
                }

                function countdownCallback(event) {
                    let $wrapCountdown = this.closest(
                        ".ecom-collection__product-countdown-wrapper"
                    );
                    let $progressbar = $wrapCountdown.querySelector(
                            ".ecom-collection__product-countdown-progress-bar"
                        ),
                        $timer = $wrapCountdown.querySelector(
                            ".ecom-collection__product-countdown-progress-bar--timer"
                        ),
                        from = this.getAttribute("data-ecom-countdown-from") || 0;


                    this.innerHTML = event.strftime(format);
                    if ($progressbar && from) {
                        let now_time = new Date().getTime(),
                            start = new Date(from),
                            start_time = start.getTime(),
                            end_time = event.finalDate.getTime();
                        if (start_time < now_time && end_time > start_time) {
                            $progressbar.style.removeProperty("display");
                            let total = end_time - start_time;
                            let elapse = end_time - now_time;
                            let result = Math.round((elapse * 100) / total) + "%";
                            // value.innerHTML = result;
                            $timer.style.width = result;
                        } else {
                            $progressbar.style.display = "none";
                        }
                    }
                }
                function initCountdown(element) {
                    if (element.dataset.ecomCountdown) {
                        if (element.dataset.ecomCountdownFrom) {
                            if (
                                new Date().getTime() >
                                    new Date(element.dataset.ecomCountdown).getTime() &&
                                isLive
                            ) {
                                element.closest(
                                    ".ecom-collection__product-countdown-wrapper"
                                ).style.display = "none";
                                return false;
                            }
                        }
                        window.EComCountdown &&
                        window.EComCountdown(element,
                                new Date(element.dataset.ecomCountdown),
                                countdownCallback
                            )
                        element.addEventListener("stoped.ecom.countdown", () => {
                            element.closest(
                                ".ecom-collection__product-countdown-wrapper"
                            ).style.display = "none";
                        });
                    }
                }

                $el.querySelectorAll(".ecom-collection__product-countdown-time").forEach(
                    function(element) {
                        initCountdown(element);
                    }
                );
                function handleProgressPagination(ajax = false, clickLoadMore) {
                    // ecom-pagination-progress-bar--wrapper
                    // .ecom-paginate__progress-text

                    const track = $el.querySelector('.ecom-paginate__progress-bar--outner'),
                          progress = $el.querySelector('.ecom-paginate__progress-bar--inner'),
                          text = $el.querySelector('.ecom-paginate__progress-text');
                    if(!show_progress_pagination || !isLive || !track || !progress || !text) return
                    let {total, initProduct} = track && track.dataset,
                        textInner = text && text.dataset.text,
                        count = 0,
                        start = 1,
                        end = 0,
                        percent = 0;
                    initProduct = parseInt(initProduct);
                    if(!ajax) {
                        if(window.location.href.match(/page=\d*/gm)){
                            const urlObject = new URL(window.location.href);
                            count = urlObject.searchParams.get("page");
                            if(count === 1 ) {
                                start = 1;
                            }
                            else {
                                start = initProduct * (count-1) + 1;
                            }
                        }
                        end = start + initProduct - 1;
                    }
                    else {
                        start = 1;
                        end = initProduct * clickLoadMore;
                    }
                    if(end > total) end = total;
                    percent = Math.round((end / total) * 100);
                    progress.style.width = `${percent}%`;
                    textInner = textInner.replace('{_start}', start);
                    textInner = textInner.replace('{_end}', end);
                    textInner = textInner.replace('{_total}', total);
                    text.innerText = textInner;
                }
                handleProgressPagination(false, 1);
                // Loadmore
                if(isLive) {
                    const main_wrapper =  $el.querySelector(".ecom-collection__product-main");
                    let clickLoadMore = 1;
                    const handleClickLoadmore = function(e) {
                        e.preventDefault();
                        const url = this.dataset.get;
                        const wrapper = this.closest('.ecom-sections[data-section-id]');
                        const section_wrapper = $el.closest('.ecom-row.ecom-section');
                        if(!url || !wrapper || !wrapper.dataset.sectionId) return;

                        const section_id = wrapper.dataset.sectionId;
                        const fetch_url = `${url}&section_id=${section_id}`;
                        clickLoadMore++;
                        handleProgressPagination(true, clickLoadMore);
                        this.classList.add('ecom-loading');

                        handleLoadProduct(fetch_url, wrapper, this, 'loadmore', section_wrapper)
                    }

                    const handleInfiniteScroll = function(loadmore) {
                        function addObserver(el, options) {
                            let observer = new IntersectionObserver((entries, observer) => {
                                entries.forEach((entry) => {
                                    if (entry.isIntersecting) {
                                        if (options.cb) {
                                            options.cb(el);
                                        } else {
                                        handleLoad(entry.target)
                                        }
                                        observer.unobserve(entry.target);
                                    }
                                });
                            }, options);
                            observer.observe(el);
                        }

                        function handleLoad(el) {
                            const url = el.dataset.get;
                            const wrapper = el.closest('.ecom-sections[data-section-id]');
                            const section_wrapper = el.closest('.ecom-row.ecom-section');
                            if(!url || !wrapper || !wrapper.dataset.sectionId) return;

                            const section_id = wrapper.dataset.sectionId;
                            const fetch_url = `${url}&section_id=${section_id}`;
                            if(flagInfinite) {
                                $el.classList.add('ecom-doing-scroll');
                                handleLoadProduct(fetch_url, wrapper, el, 'infinite', section_wrapper)
                            }
                        }

                        addObserver(loadmore, {});

                        }

                        const handleLoadProduct = function(fetch_url, wrapper, btn, type, section_wrapper) {
                            flagInfinite = false;
                            const loadProduct = async function(url) {
                                const response = await fetch(url, {
                                method: 'GET',
                                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                                headers: {
                                    'Content-Type': 'text/html'
                                },
                                });
                                return response.text();
                            }

                            loadProduct(fetch_url).then(function(data) {
                                const dom = document.createElement('div');
                                dom.innerHTML = data;
                                const products_item = dom.querySelector('.ecom-collection__product-main.ecom-collection_product_template_collection.ecom-variable-product .ecom-collection__product--wrapper-items');

                                if(!products_item) return;

                                const wrapper_products =  section_wrapper.querySelector('.ecom-variable-product .ecom-collection__product--wrapper-items');
                                const loadmore_wrapper = section_wrapper.querySelector('.ecom-products-pagination-loadmore');

                                while(products_item.firstChild) {
                                    wrapper_products.appendChild(products_item.firstChild);
                                }

                                products_item.parentNode.removeChild(products_item);

                                if(type === 'loadmore') {
                                    const loadmore = dom.querySelector('.ecom-products-pagination-loadmore');
                                    if(loadmore) {
                                        loadmore_wrapper.innerHTML = loadmore.innerHTML;
                                        // loadmore_wrapper.querySelector('.ecom-products-pagination-loadmore-btn') &&
                                        // loadmore_wrapper.querySelector('.ecom-products-pagination-loadmore-btn').addEventListener('click', handleClickLoadmore);
                                    } else {
                                        loadmore_wrapper.remove();
                                    }
                                } else {
                                    btn.remove();

                                    const loadmore = dom.querySelector('.ecom-products-pagination-infinite');
                                    if(loadmore) {
                                        wrapper_products.after(loadmore);
                                        handleInfiniteScroll(loadmore)
                                    }
                                }
                                main_wrapper.dispatchEvent(new CustomEvent('ecom-products-init',{
                                    detail: {
                                    wrapper: main_wrapper
                                    }
                                }))
                            })
                            .finally(function() {
                                if(window.EComposer) window.EComposer.initQuickview();
                                flagInfinite = true;
                                $el.classList.remove('ecom-doing-scroll');
                                btn.classList.remove('ecom-loading')
                            })
                        }

                    if(main_wrapper && main_wrapper.dataset.pagination) {
                        const pagination = main_wrapper.dataset.pagination;

                        if(pagination === 'loadmore') {
                            $el.querySelector('.ecom-products-pagination-loadmore-btn') &&
                            $el.querySelector('.ecom-products-pagination-loadmore-btn').addEventListener('click', handleClickLoadmore);
                        } else if (pagination === 'infinit') {
                            const loadmore = $el.querySelector('.ecom-products-pagination-infinite');
                            if(!loadmore) return;
                            handleInfiniteScroll(loadmore);
                        }
                    }

                    main_wrapper.addEventListener('ecom-products-init', function(e) {
                        const wrapper = e.detail.wrapper;
                        if(!wrapper) return;
                        if(main_wrapper && main_wrapper.dataset.pagination) {
                            const pagination = main_wrapper.dataset.pagination;

                            if(pagination === 'loadmore') {
                                $el.querySelector('.ecom-products-pagination-loadmore-btn') &&
                                $el.querySelector('.ecom-products-pagination-loadmore-btn').addEventListener('click', handleClickLoadmore);
                            } else if (pagination === 'infinit') {
                                const loadmore = $el.querySelector('.ecom-products-pagination-infinite');
                                if(loadmore) {
                                    handleInfiniteScroll(loadmore);
                                }
                            }
                        }
                        //Options selector
                        wrapper.querySelectorAll(".ecom-collection__product-variants:not(.ecom-swatch-init)").length &&
                        wrapper.querySelectorAll(".ecom-collection__product-variants:not(.ecom-swatch-init)").forEach(executeShopifyOptionSelectors);
                        //Countdown
                        wrapper.querySelectorAll(".ecom-collection__product-countdown-time").length &&
                        wrapper.querySelectorAll(".ecom-collection__product-countdown-time").forEach(
                            function(element) {
                                initCountdown(element);
                            }
                        );
                        // handleQuickShopBtn(wrapper);
                        //Loadmore
                        wrapper.querySelector('.ecom-products-pagination-loadmore-btn') &&
                        wrapper.querySelector('.ecom-products-pagination-loadmore-btn').addEventListener('click', handleClickLoadmore);

                        //ATC
                        window.EComposer && typeof window.EComposer.init === 'function' && window.EComposer.init();

                        //Thrity Apps
                        initReviewApps(wrapper);

                        const $wishlistWrapper = wrapper.querySelector(
                            ".ecom-collection__product--wishlist-wrapper"
                        );
                        initWishlistApps($wishlistWrapper)
                    })
                }

                function initReviewApps($wrapper) {
                    if ($wrapper && $wrapper.dataset.reviewPlatform) {
                        switch ($wrapper.dataset.reviewPlatform) {
                            case "product-reviews":
                                if (window.SPR) {
                                    try {
                                        window.SPR.$ = window.jQuery;
                                        window.SPR.initDomEls();
                                        window.SPR.loadBadges();
                                    } catch (e) {
                                        console.info(e.message);
                                    }
                                }
                                break;
                            case "judgeme":
                                if (window.jdgm) {
                                    try {
                                        window.jdgm.batchRenderBadges();
                                    } catch (e) {
                                        console.info(e.message);
                                    }

                                        $el.querySelectorAll('[data-average-rating="0.00"]').forEach(function (e) {
                                            e.style.display = "block !important";
                                        });
                                }
                                break;
                            case "product-reviews-addon":
                                if (window.StampedFn) {
                                    window.StampedFn.loadBadges();
                                }
                                break;
                            default:
                                break;
                        }
                    }
                }

                function initWishlistApps($wishlistWrapper) {
                    if ($wishlistWrapper) {
                        switch ($wishlistWrapper.dataset.wishlistApp) {
                            case "swym-relay":
                                if (window._swat) {
                                    window._swat.initializeActionButtons(
                                        ".ecom-collection__product-wishlist-button"
                                    );
                                }
                                break;
                            case "wishlist-hero":
                                $el.querySelectorAll(".wishlist-hero-custom-button").forEach(
                                    function (wishlistButton) {
                                        var ev = new CustomEvent(
                                            "wishlist-hero-add-to-custom-element",
                                            {
                                                detail: wishlistButton
                                            }
                                        );
                                        document.dispatchEvent(ev);
                                    }
                                );
                                break;
                            case "wishlist-wishify":
                                // var dom = document.createElement('script');
                                // dom.src = 'https://zooomyapps.com/wishlist/ListWishlistProduct.js';
                                // window.document.head.appendChild(dom);
                                break;
                            default:
                                break;
                        }
                    }
                }

                if (!isLive) {
                    const $wrapper = $el.querySelector(".ecom-collection__product-main");
                    initReviewApps($wrapper);

                    const $wishlistWrapper = $el.querySelector(
                        ".ecom-collection__product--wishlist-wrapper"
                    );
                    initWishlistApps($wishlistWrapper)
                }

                //Preload
                if(this.settings.enable_preload) {
                    var $product_list = $el.querySelectorAll('.ecom-collection__product-item');
                    $product_list.forEach(function(product) {

                        product.addEventListener('mouseenter', function() {
                            let prefetcher = document.createElement("link");
                            prefetcher.rel = "prefetch",
                            document.head.appendChild(prefetcher);
                            var link = this.querySelector('a.ecom-collection__product-item-information-title').getAttribute('href');
                            prefetcher.href = link;
                        },{ once: true})
                    })
                }

                // Compare
                if(this.settings.show_compare) {
                    // var $compare_button_list = $el .querySelectorAll('.ecom-collection__product-compare-link');
                    // var settings = this.settings
                    // $compare_button_list.forEach(function(compare_button) {
                    //     compare_button.addEventListener('click', function() {
                    //         // Change label, icon and tooltip to added
                    //         var label = this.querySelector('.ecom-collection__product-compare-label');
                    //         var icon = this.querySelector('.ecom-collection__product-compare-icon');
                    //         var tooltip = this.querySelector('.ecom-collection__product-compare-tooltip');
                    //         if (label && settings.compare_label_added)
                    //             label.innerHTML = settings.compare_label_added;
                    //         if (icon && settings.compare_icon_added)
                    //             icon.innerHTML = settings.compare_icon_added.value;
                    //         if (tooltip && settings.content_tooltip_added)
                    //             tooltip.innerHTML = settings.content_tooltip_added;
                    //     })
                    // })
                }

                    });
                    
                        document.querySelectorAll('.ecom-l1sdhijfpqj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l1sdhijfpqj', settings: {"layout":"grid","enable_preload":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}